<head>
  
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <meta name="description"
    content="Discover Connected Insurance for Freightliner and Western Star. Share your Detroit Connect® data to earn custom rates and insurance savings." />
    <link rel="alternate" hreflang="en-us" href="https://daimler-truckfinancial.com/home" />
    <link rel="alternate" hreflang="en-ca" href="https://daimler-truckfinancial.com/ca/en/home" />
    <link rel="alternate" hreflang="fr-ca" href="https://daimler-truckfinancial.com/ca/fr/home" />
    <link rel="alternate" hreflang="x-default" href="https://daimler-truckfinancial.com/home" />
  </head>

<div class="dtf-carousel">
  <ngb-carousel
    [animation]="false"
    [interval]="myInterval"
    [keyboard]="false"
    [showIndicators]="false"
    [noPause]="false"
    [wrap]="true"
    [showNavigationArrows]="false"
    *ngIf="!displayStatic"
  >
    <ng-template ngbSlide *ngFor="let slider of sliders; let i = index">
      <section
        class="mbfs-home-hero"
        id="mbfs-{{ i }}"
        [ngStyle]="{ 'background-image': 'url(' + slider.bannerImgUrl + ')' }"
      >
        <section
          class="mbfs-home-hero__header"
          [ngClass]="{
            'mbfs-home-hero__header__top': slider.bannerTxtPosition === 'top',
            'mbfs-home-hero__header__mid': slider.bannerTxtPosition === 'mid',
            'mbfs-home-hero__header__bot': slider.bannerTxtPosition === 'bot',
            'align-left': slider.bannerExtra === 'L',
            'align-right': slider.bannerExtra === 'R'
          }"
        >
          <h2 class="mbfs-home-hero__header-subtitle">{{ slider.bannerHeader }}</h2>

          <div [attr.aria-label]="slider.bannerCopy">
            <p
              class="mbfs-home-hero__header-text"
              role="heading"
              *ngIf="!isBlank(slider.bannerCopy)"
            >
              {{ slider.bannerCopy }}
            </p>
          </div>

          <div class="centerimage">
            <div class="mbfs-home-hero-small">
              <section
                class="mbfs-home-hero-small"
                *ngIf="!isBlank(slider.bannerEnableInsert)"
                [ngStyle]="{ 'background-image': 'url(' + slider.bannerInsertImgUrl + ')' }"
              ></section>
            </div>
          </div>

          <div class="button" *ngIf="isBlank(slider.bannerExtra2)">
            <a
              *ngIf="!isBlank(slider.btnLabel)"
              class="mbfs-button"
              [href]="slider.btnUrl"
            >
              {{ slider.btnLabel }}
            </a>
          </div>

          <div *ngIf="!isBlank(slider.bannerExtra2)">
            <a
              *ngIf="!isBlank(slider.btnLabel)"
              class="mbfs-button"
              (click)="clickvideo(slider.btnUrl)"
              href="javascript:void(0);"
            >
              {{ slider.btnLabel }}
            </a>
          </div>
        </section>
      </section>

      <section
        *ngIf="slider.bannerName === 'en-US-BannerLeft'"
        class="mbfs-repay-banner-inner"
        style="background-color: #00566A;"
      >
        <div class="mbfs-repay-banner-inner__box">
          <div class="mbfs-repay-banner-inner__box--text2">
            <img
              src="static/assets/img/dtf-assets/images/redesign/logoTest.png"
              alt="Connected Insurance banner showing telematics data translating into insurance savings for owner-operators and fleets"
            />
          </div>
        </div>
      </section>
    </ng-template>
  </ngb-carousel>
</div>


<!-- Guest Pay Banner -->
<section>
  <div
    style="background-color: white; display: flex; flex-direction: column; justify-content: center; border-bottom: #4F4D4A solid 1px; align-items: center; text-align: center;">
    <img src="static/assets/img/dtf-assets/images/redesign/guestpay2.svg" alt=""
      style="max-width: 100%; height: auto; object-fit: cover; object-position: center bottom; transform: translateY(-12%);">

    <p class="mbfs-repay-banner-inner__header-text" style="color: #4F4D4A; margin: 0; transform: translateY(-200%);">
      {{ 'HomePage.Guestpaytext' | translate }}
    </p>

    <div class="button" style="display: inline-block; text-align: center; transform: translateY(-70%); color: white; text-decoration: none;">
    <a class="mbfs-button-1" style="text-decoration: none; color: white;"
      href="{{this.fullGuestPayUrl}}">
      {{ 'HomePage.Guestpaytext2' | translate }}
    </a>
    </div>
  </div>
</section>

<!-- <div class="image-swipe-container">

  <div class="image-swipe-track" #swipeTrack>
    <div
      class="image-swipe-card"
      *ngFor="let item of cards"
      [style.backgroundImage]="'url(' + item.image + ')'"
      (click)="goTo(item.route)"
    >
      <div class="image-swipe-title">
        <h4>{{ item.title }}</h4>
      </div>
    </div>
  </div> -->

<!-- Navigation buttons -->
<!-- <div class="image-swipe-actions">
    <button mat-mini-fab (click)="slideLeft()">‹</button>
    <button mat-mini-fab (click)="slideRight()">›</button>
  </div>

</div> -->

<div class="onlinebackground">
  <section class="mercedes-me-login">
    <div class="mercedes-me-login__column">
      <h2 class="mercedes-me-login__column-headline">{{ 'HomePage.OnlineAcctHeader' | translate }}</h2>
      <ul class="mercedes-me-login__column-app-promotion-ul">
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext1' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext2' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext3' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext4' | translate }}</li>
        <li class="mercedes-me-login__column-app-promotion-info">{{ 'HomePage.Onlinetext5' | translate }}</li>
      </ul>
    </div>
  </section>
</div>

<section class="mbfs-home-insurance">
  <div class="mbfs-home-insurance__content"></div>
</section>

<div *ngIf="passwordResetFlag">
  <div class="dtf-passwordresetconfirmpage"></div>
</div>

<div *ngIf="RegistrationPopup">
  <div class="dtf-registrationPopuppage"></div>
</div>

<div *ngIf="RegistrationConfirmFlag">
  <div class="dtf-registrationConfirm"></div>
</div>